import {
  ClipboardCheck,
  Plus,
} from "lucide-react";
import {
  can,
} from "../../../../shared/auth/access";
import { ModuleHeader } from "../../../../shared/components/ModuleHeader";
import { OfferComparison } from "./OfferComparison";
import { OfferComposer } from "./OfferComposer";
import { OfferDecision } from "./OfferDecision";
import { OfferLedger } from "./OfferLedger";
import { useOffersWorkspace, type OffersModuleProps } from "./useOffersWorkspace";

export function OffersModule(props: OffersModuleProps) {
  const model = useOffersWorkspace(props);
  const {
    user,
    setDecisionEditorOpen,
    activeCorrection,
    approvalStarted,
    evaluationReady,
    canManageActiveOffers,
    openNewOffer,
  } = model;
  return (<>
    <ModuleHeader
      eyebrow="Ticari değerlendirme"
      title="Teklifler"
      description="Tedarikçi tekliflerini ortak koşullarda karşılaştırın ve eksik bilgileri tamamlayın."
      action={
        can(user, "offer.manage") ? (
          <div className="header-actions offer-header-actions">
            {user.role === "SATIN_ALMA" &&
              evaluationReady &&
              (!activeCorrection || activeCorrection.hasOfferChange) &&
              !approvalStarted ? (
              <button
                type="button"
                className="approve-button"
                onClick={() => setDecisionEditorOpen(true)}
              >
                <ClipboardCheck size={16} /> Karar ver
              </button>
            ) : null}
            {canManageActiveOffers ? (
              <button className="primary-button" onClick={openNewOffer}>
                <Plus size={16} /> Teklif ekle
              </button>
            ) : null}
          </div>
        ) : undefined
      }
    />
    <OfferComposer model={model} />
    <OfferLedger model={model} />
    <OfferComparison model={model} />
    <OfferDecision model={model} />
  </>);
}
